import { cn } from '@/lib/utils';

/**
 * The first thing in the tab order, visible only when focused.
 *
 * **WCAG 2.4.1 "Bypass Blocks", which is a Level A requirement** — the lowest
 * bar there is, and the one this application failed on three of its four
 * surfaces until 13.3.
 *
 * The public site has had one since 8.4, with a comment explaining that a
 * keyboard user otherwise tabs through the whole header before reaching the
 * content. The three signed-in portals did not, and they are far worse: the
 * admin sidebar is **twenty-two links**, measured, in front of every page.
 * Somebody navigating by keyboard pressed Tab twenty-three times to reach the
 * first control that does anything, on every single page load.
 *
 * Shared rather than copied a fourth time, and the copy that existed is now
 * this one.
 *
 * `href="#main"` needs a `<main id="main" tabIndex={-1}>` to land on. The
 * `tabIndex` matters and is easy to leave off: without it the fragment moves
 * the scroll position but several browsers leave focus where it was, so the
 * next Tab goes back to the second nav link and the skip link silently does
 * nothing.
 */
export function SkipLink() {
  return (
    <a
      href="#main"
      className={cn(
        'sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50',
        'focus:rounded-md focus:bg-honey-400 focus:px-4 focus:py-3 focus:text-label focus:text-ink-900',
        'focus:outline-none focus:ring-2 focus:ring-honey-700 focus:ring-offset-2',
      )}
    >
      Skip to content
    </a>
  );
}
